import { Box, Container, Grid } from '@chakra-ui/react'
import { EventCard, MotionBox } from '@ui'
import { observer } from 'mobx-react-lite'
import { ITabData } from '@interfaces'
import { ContentNotFound } from '@common'
import { fadeIn } from '@lib/motion'

interface IMuseumProgram {
  tabData: ITabData[] | undefined
}


const MuseumProgramWhatson = observer(({ tabData }: IMuseumProgram) => {
  if (!Array.isArray(tabData) || tabData.length === 0) {
    console.warn('MuseumProgramWhatson: tabData boş veya tanımsız geldi.')
    return (
      <Box as="section">
        <Container>
          <ContentNotFound minHeight="50vh" />
        </Container>
      </Box>
    )
  }

  const allTab =
    tabData.find((tab) => tab?.tabLabelTx === 'common:tabs.allTab') ||
    tabData[0]

  const content = Array.isArray(allTab?.tabContent) ? allTab.tabContent : []




  return (
    <Box as="section">
      <Container>
        {content.length === 0 ? (
          <ContentNotFound minHeight="50vh" />
        ) : (
          <Grid
            display="grid"
            gridTemplateColumns={{
              base: '1fr',
              md: 'repeat(3, 1fr)',
              lg: 'repeat(3, 1fr)',
            }}
            gridRowGap={{ base: 'padding.primary', lg: 9 }}
            gridColumnGap={{ base: 0, lg: 5 }}
            pt={{ base: '30px', lg: '30.75px' }}
            px={0}
            justifyItems="center"
          >
            {content.map((card, index) => (
              <Box
                key={card.id ?? `event-${index}`}
                width="full"
                overflow="hidden"
              >
                <MotionBox
                  key={`${card.id ?? `event-${index}`}-${index}`}
                  initial="hidden"
                  animate="visible"
                  variants={fadeIn.up}
                  transition={{ duration: 0.35, delay: index * 0.04 }}
                >
                  <EventCard {...card} />
                </MotionBox>
              </Box>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  )
})

export default MuseumProgramWhatson
